// src/components/tribunal/FormTribunal/sections/DatosGeneralesSection.jsx
import React from "react";
import { AutoComplete, Select, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const { Text } = Typography;

export default function DatosGeneralesSection({
  onOpenAutofill,
  fieldMeta,
  form,
  errors,

  expedienteSearchValue,
  expedienteOptions,
  expedienteSearching,
  handleExpedienteFocus,
  handleExpedienteSearch,
  handleExpedienteSelect,
  handleExpedienteChange,

  selectedEstadoId,
  selectedCiudadId,
  selectedAutoridadId,
  estadosOptionsFinal,
  ciudadesOptionsFinal,
  autoridadOptions,
  handleChangeEstado,
  handleChangeCiudad,
  handleChangeAutoridad,

  allRazonesSociales,
  handleChangeRazonSocial,
  onOpenNuevaEmpresa,

  setField,
  modoRapido = false,
  onToggleModoRapido,
  isEdit = false,
})


{
  const chip = (key, manual = false) => {
    if (manual) return <span className="oa-chip-manual">MANUAL</span>;
    const m = fieldMeta?.(key);
    if (!m) return null;
    if (m.needsReview) return <span className="oa-tag-review" title={m.reviewReason}><span className="material-symbols-outlined" style={{ fontSize: 11, verticalAlign: "middle" }}>warning</span> REVISAR</span>;
    if (m.isAI) return <span className="oa-chip-ai">IA</span>;
    return null;
  };
  const fw = (key) => `oa-field${fieldMeta?.(key)?.needsReview ? " oa-field-review" : ""}`;

  return (
    <section className="oa-card">
      <div className="oa-card-head oa-head-split">
        <h2 className="oa-card-title">
          <span className="oa-card-icon">
            <i className="fa-solid fa-folder-open" />
          </span>
          DATOS GENERALES DEL EXPEDIENTE
        </h2>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <button type="button" className="oa-btn-autofill" onClick={onOpenAutofill}>
            <span className="material-symbols-outlined" style={{ fontSize: 16 }}>auto_awesome</span>
            Autorelleno Formulario
          </button>
        </div>
      </div>

      <div className="oa-card-body oa-grid-3">
        

        <div className={fw("numero_expediente")}>
          <label className="oa-label">
            <span className="oa-req">*</span> Número de Expediente {chip("numero_expediente")}
          </label>
          <input
            className={`oa-input ${errors.numero_expediente ? "oa-input-error" : ""}`}
            type="text"
            placeholder="Número de expediente"
            value={form.numero_expediente}
            onChange={(e) => setField("numero_expediente", e.target.value)}
          />
          {errors.numero_expediente ? <div className="oa-error">{errors.numero_expediente}</div> : null}
        </div>

        <div className={fw("nombre_parte_actora")}>
          <label className="oa-label">
            <span className="oa-req">*</span> Nombre de la Parte Actora {chip("nombre_parte_actora")}
          </label>
          <input
            className={`oa-input ${errors.nombre_parte_actora ? "oa-input-error" : ""}`}
            type="text"
            placeholder="Nombre de la parte actora"
            value={form.nombre_parte_actora}
            onChange={(e) => setField("nombre_parte_actora", e.target.value)}
          />
          {errors.nombre_parte_actora ? <div className="oa-error">{errors.nombre_parte_actora}</div> : null}
        </div>
        <div className={fw("empresa_razon_social_ids")}>
          <label className="oa-label">
            <span className="oa-req">*</span> Razón Social {chip("empresa_razon_social_ids")}
          </label>

          <div className={errors.empresa_razon_social_ids ? "oa-ant-error" : ""}>
            <Select
              mode="multiple"
              value={form.empresa_razon_social_ids || []}
              placeholder="Seleccionar razón(es) social(es)"
              onChange={handleChangeRazonSocial}
              style={{ width: "100%" }}
              showSearch
              optionFilterProp="label"
              options={(allRazonesSociales || []).map((o) => ({
                label: o.label,
                value: String(o.value == null ? o.label : o.value),
              }))}
            />
          </div>

          <div style={{ marginTop: 6 }}>
            <Text
              style={{
                fontSize: 12,
                color: "#0A539A",
                cursor: "pointer",
                textDecoration: "underline",
                userSelect: "none",
              }}
              onClick={onOpenNuevaEmpresa}
            >
              <PlusOutlined style={{ marginRight: 3 }} />
              ¿Empresa nueva? Créala aquí
            </Text>
          </div>

          {errors.empresa_razon_social_ids ? <div className="oa-error">{errors.empresa_razon_social_ids}</div> : null}
        </div>
        <div className={fw("estado")}>
          <label className="oa-label">
            <span className="oa-req">*</span> Estado {chip("estado")}
          </label>
          <select
            className={`oa-input ${errors.estado ? "oa-input-error" : ""}`}
            value={selectedEstadoId ?? ""}
            onChange={(e) => handleChangeEstado(e.target.value ? Number(e.target.value) : null)}
          >
            <option value="">Seleccionar estado</option>
            {estadosOptionsFinal.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
          {errors.estado ? <div className="oa-error">{errors.estado}</div> : null}
        </div>

        <div className={fw("ciudad")}>
          <label className="oa-label">
            <span className="oa-req">*</span> Ciudad {chip("ciudad")}
          </label>
          <select
            className={`oa-input ${errors.ciudad ? "oa-input-error" : ""}`}
            value={selectedCiudadId ?? ""}
            onChange={(e) => handleChangeCiudad(e.target.value ? Number(e.target.value) : null)}
            disabled={!selectedEstadoId}
          >
            <option value="">Seleccionar ciudad</option>
            {ciudadesOptionsFinal.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
          {errors.ciudad ? <div className="oa-error">{errors.ciudad}</div> : null}
        </div>

        <div className={fw("autoridad")}>
          <label className="oa-label">
            <span className="oa-req">*</span> Autoridad {chip("autoridad")}
          </label>
          <select
            className={`oa-input ${errors.autoridad ? "oa-input-error" : ""}`}
            value={selectedAutoridadId ?? ""}
            onChange={(e) => handleChangeAutoridad(e.target.value)}
            disabled={!selectedCiudadId}
          >
            <option value="">Seleccionar autoridad</option>
            {autoridadOptions.map((o) => (
              <option key={String(o.value)} value={String(o.value)}>
                {o.label}
              </option>
            ))}
          </select>
          {errors.autoridad ? <div className="oa-error">{errors.autoridad}</div> : null}
        </div>
{!modoRapido && <div className={fw("abogado_contrario")}>
  <label className="oa-label">
    Abogado Parte Actora {chip("abogado_contrario")}
  </label>
  <input
    className={`oa-input`}
    type="text"
    placeholder="Nombre del abogado parte actora"
    value={form.abogado_contrario || ""}
    onChange={(e) => setField("abogado_contrario", e.target.value)}
  />

</div>}
   

        

        

        <div className="oa-field">
          <label className="oa-label">Corresponsal (nombre) {chip("corresponsal_nombre", true)}</label>
          <input
            className="oa-input"
            type="text"
            placeholder="Nombre del corresponsal empresa"
            value={form.corresponsal_nombre || ""}
            onChange={(e) => setField("corresponsal_nombre", e.target.value)}
            disabled={Number(form.cliente_directo || 1) === 1}
          />
          {errors.corresponsal_nombre ? <div className="oa-error">{errors.corresponsal_nombre}</div> : null}
        </div>
           {!modoRapido && <div className={fw("num_unico")}>
          <label className="oa-label">
           Núm. Único de Identificación {chip("num_unico")}
          </label>

          <AutoComplete
            value={expedienteSearchValue || form.num_unico}
            options={expedienteOptions}
            onFocus={handleExpedienteFocus}
            onSearch={handleExpedienteSearch}
            onSelect={handleExpedienteSelect}
            onChange={handleExpedienteChange}
            filterOption={false}
            notFoundContent={expedienteSearching ? "Buscando..." : "Sin resultados"}
          >
            <input
              className={`oa-input`}
              type="text"
              placeholder="Ej. SLRC/001/2024"
              value={expedienteSearchValue || form.num_unico}
              onChange={(e) => handleExpedienteChange(e.target.value)}
            />
          </AutoComplete>

        </div>}
      </div>
    </section>
  );
}